<template>
    <v-container>

        <v-layout row wrap pt-4 align-center>
            <v-flex xs12 md6>
                <h2>Representatives of {{this.State}}</h2>
            </v-flex>
            <v-flex xs12 offset-md2 md4>
                <v-text-field v-if="!loading" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-layout>

        <template>
            <v-card v-if="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-if="!loading"> 
            <v-data-table :headers="HEADERS" :items="STATE" :rows-per-page-items="ROWS_LISTITEMS" :pagination.sync="PAGINATION" :search="search" disable-initial-sort>
                <template v-slot:items="props">
                    <router-link class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                        <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                        <td class="text-xs-left">{{props.item.DisplayName}}</td>
                        <td class="text-xs-left">{{props.item.MPorSenator[0]}}</td>
                        <td class="text-xs-left">{{props.item.Party}}</td>
                        <td class="text-xs-right">{{props.item.ServiceHistory_Start | stringDateFormat}}</td>
                        <td class="text-xs-right">{{props.item.ServiceHistory_End | stringDateFormat}}</td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>
        </div>

    </v-container>
</template>

<script>
    window.scrollTo(0, 0);
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    import Portrait from '@/components/Portrait.vue'

    export default {

        components: {
            Portrait
        },

        props: {
            State: {
                type: String,
                required: true,
            },
        },
        created() {
            this.loadParliamentarians();
        },
        data() {
            return {
                loading: true,
                STATE: [],
                search: '',
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [
                    {
                        text: 'Image',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: false,
                    },
                    {
                        text: 'Name',
                        value: 'DisplayName',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        text: 'MP or Senator',
                        value: 'MPorSenator',
                        align: 'left',
                        sortable: true,

                    },
                    {
                        text: 'Party',
                        value: 'Party',
                        align: 'left',
                        sortable: true,

                    },
                    {
                        text: 'Served from',
                        value: 'ServiceHistory_Start',
                        align: 'right',
                        sortable: true,
                        sort: (a, b) => this.$moment(a) > this.$moment(b)
                    },

                    {
                        text: 'Served to',
                        value: 'ServiceHistory_End',
                        align: 'right',
                        sortable: true,
                        sort: (a, b) => this.$moment(a) > this.$moment(b)
                    },
                ],
            }
        },
        methods: {
            loadParliamentarians() {
                this.loading = true;
                const url = `individuals?select=PHID,DisplayName,MPorSenator,ServiceHistory_Start,ServiceHistory_End&$filter=RepresentedStates/any(s:s eq '${this.State}')`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.STATE = response.data.value.sort((a, b) => this.$moment(a.ServiceHistory_Start) < this.$moment(b.ServiceHistory_Start) ? -1 : 1);
                        this.loading = false;
                    });
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    a {
        color: #fff;
        text-decoration: underline;
    }

    .text-xs-left {
        cursor: pointer;
    }
</style>
